import { LiveAnnouncer } from '@angular/cdk/a11y';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dialog-form',
  templateUrl: './dialog-form.component.html',
  styleUrls: ['./dialog-form.component.css'],
})
export class DialogFormComponent implements OnInit {
  numberOS: any = this.data.numberOS;

  constructor(
    public dialogRef: MatDialogRef<DialogFormComponent>,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private _liveAnnouncer: LiveAnnouncer,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AventuraService,
    private http: HttpClient,
    private toastr: ToastrService,
    private fileService: FileService
  ) {}

  @ViewChild(MatSort) sort: any;
  nota = {
    reef: 0,
    saf: 0,
    penalidad: 0,
    fileNumber: this.data.fileNumber,
    nameProveedor: this.data.nameProveedor,
    numberOS: this.data.numberOS,
    idItinerary: this.data.idItinerary,
    estado: 'CREADO',
    partialPayment: 0,
    moneda: this.data.moneda,
  };

  ngOnInit(): void {}

  submitForm() {
    const numberOS = Number(this.data.numberOS);
    const notaCredito = this.nota;

    if (
      this.nota.reef +
        this.nota.saf +
        this.nota.penalidad +
        this.nota.partialPayment ===
      this.data.monto
    ) {
      throw new Error('Function not implemented.');
      // this.fileService
      //   .createNotaCreditoProveedor(notaCredito, numberOS)
      //   .subscribe({
      //     next: (value3) => console.log(value3),
      //     error: (error) => console.error(error),
      //     complete: () => {
      //       Swal.fire({
      //         position: 'top-end',
      //         icon: 'success',
      //         title: 'Se creó la Nota de Credito',
      //         showConfirmButton: false,
      //         timer: 4000,
      //       });
      //       this.dialogRef.close(true);
      //     },
      //   });
    } else {
      this.toastr.warning('Ingrese datos correctos', 'Importante');
    }
  }

  close() {
    console.log('COSEEEEEEEEEEEE');
    this.dialogRef.close(false);
  }
}
